// videocards strings (fr). Machine-drafted — review with a native speaker before launch.
const videocards = {
	videocards: {
		// ===== List page (index.tsx) =====
		helmetList: 'Cartes vidéo | CardClan',
		helmetDetails: 'Détails de la carte vidéo | CardClan',
		backToVideoCards: 'Retour aux cartes vidéo',
		title: 'Cartes vidéo',
		subtitle: 'Créez et gérez des cartes de vœux vidéo',
		createVideoCard: 'Créer une carte vidéo',

		// Upgraded success banner
		bannerStackAdded: 'lot ajouté',
		bannerActivated: 'activée',
		upgradedBanner: 'Offre à vie %{state} ! Vous avez maintenant %{cards} cartes vidéo et %{minutes} minutes de rendu par mois.',

		// Workspace disabled
		workspaceDisabledAlert: 'Les cartes vidéo sont désactivées pour cet espace de travail. Contactez l\'administrateur de votre espace de travail.',
		workspaceDisabledBanner: 'Les cartes vidéo sont désactivées pour cet espace de travail. Contactez l\'administrateur de votre espace de travail pour les activer.',

		// Get Started modal
		getStartedTitle: 'Commencer',
		getStartedSubtitle: 'Configurez votre tableau de carte vidéo.',
		occasionLabel: 'Occasion',
		occasionPlaceholder: 'Saisissez ou sélectionnez une occasion...',
		loading: 'Chargement...',
		noMatchEnter: 'Aucune correspondance — appuyez sur Entrée pour utiliser « %{input} »',
		noCategories: 'Aucune catégorie trouvée',
		recipientFirstName: 'Prénom du destinataire',
		firstNamePlaceholder: 'p. ex. Sarah',
		lastName: 'Nom',
		lastNamePlaceholder: 'Facultatif',
		boardTitle: 'Titre du tableau',
		boardTitlePlaceholder: 'Généré automatiquement à partir de l\'occasion et du nom',
		themePreview: 'Thème : %{occasion} — %{font}',
		cancel: 'Annuler',
		creating: 'Création...',
		createBoard: 'Créer le tableau',

		// Auto-generated titles / fallbacks
		autoTitleHappyOccasionName: 'Joyeux %{occasion} %{name} !',
		autoTitleHappyOccasion: 'Joyeux %{occasion} !',
		autoTitleForName: 'Pour %{name}',
		untitledVideoCard: 'Carte vidéo sans titre',

		// ===== Cards list (VideoCardsList.tsx) =====
		deleteConfirmTitle: 'Supprimer la carte vidéo ?',
		deleteConfirmText: 'Cela supprimera définitivement cette carte vidéo et toutes ses contributions.',
		delete: 'Supprimer',
		noVideoCardsYet: 'Aucune carte vidéo pour le moment',
		createFirstVideoCard: 'Créez votre première carte vidéo pour commencer',
		videoCardBadge: 'Carte vidéo',
		copied: 'Copié !',
		copyInviteLink: 'Copier le lien d\'invitation',
		due: 'Échéance : %{date}',

		// ===== Usage bar (VideoCardUsageBar.tsx) =====
		progressVideoCards: 'Cartes vidéo',
		progressRenderMinutes: 'Minutes de rendu',
		tierFree: 'Gratuit',
		tierLtd: 'Offre à vie',
		upgrade: 'Améliorer',
		stackMore: 'Ajouter des lots',

		// ===== Detail (VideoCardDetail.tsx) =====
		detailHelmetFallback: 'Carte vidéo',
		statusSent: 'Envoyée',
		statusProcessing: 'En cours',
		statusScheduled: 'Programmée',
		statusDraft: 'Brouillon',
		tileSingular: 'tuile',
		tilePlural: 'tuiles',
		submissionSingular: 'contribution',
		submissionPlural: 'contributions',
		editBoard: 'Modifier le tableau',
		deliveryModeVideo: 'Vidéo',
		deliveryModeBoard: 'Tableau',
		preview: 'Aperçu %{mode}',
		sentNoEdit: 'Cette carte a été envoyée et ne peut plus être modifiée.',
		scheduledForPrefix: 'Programmée pour',
		futureDate: 'une date ultérieure',
		atLabel: 'à',
		cancelSchedule: 'Annuler la programmation',

		// Tabs
		tabContent: 'Contenu et rendu',
		tabSettings: 'Paramètres',
		tabDelivery: 'Livraison',

		// Content & render
		latestRenderedVideo: 'Dernière vidéo rendue',
		reRender: 'Refaire le rendu',
		downloadMp4: 'Télécharger le MP4',
		renderingFailed: 'Le rendu a échoué. Veuillez réessayer.',
		renderVideo: 'Rendre la vidéo',
		boardTilesHeading: 'Tuiles du tableau (%{count})',
		tileBreakdown: '%{videos} vidéos, %{texts} textes, %{images} images, %{gifs} GIF.',
		dragToReorderTiles: ' Glissez pour réorganiser.',
		noBoardTiles: 'Aucune tuile sur le tableau pour le moment. Ouvrez l\'éditeur ou partagez le lien d\'invitation.',
		videoBadge: 'Vidéo',
		creator: 'Créateur',
		videoSubmissionsHeading: 'Contributions vidéo (%{count})',
		dragReorderRenderSeq: 'Glissez pour réorganiser. L\'ordre détermine la séquence de rendu.',

		// Render steps & errors
		stepExporting: 'Exportation des captures de page...',
		stepStarting: 'Démarrage du rendu...',
		stepQueued: 'En file d\'attente...',
		stepProcessing: 'Traitement... %{progress} %',
		errRenderingFailed: 'Le rendu a échoué',
		errLostConnection: 'Connexion perdue avec la progression du rendu',
		errTimeout: 'Le rendu a expiré après 10 minutes',
		errRenderLimit: 'Limite de rendu atteinte. Améliorez votre forfait pour obtenir plus de minutes de rendu.',
		errFailedStart: 'Impossible de démarrer le rendu',

		// Save / status messages
		saved: 'Enregistré !',
		failedToSave: 'Échec de l\'enregistrement',
		scheduleCancelled: 'Programmation annulée',
		selectFutureDate: 'Veuillez sélectionner une date et une heure ultérieures',
		enterRecipientEmail: 'Veuillez saisir l\'e-mail du destinataire',
		scheduledMsg: 'Programmée !',

		// Settings tab
		contributionSettings: 'Paramètres de contribution',
		submissionDeadline: 'Date limite de contribution',
		submissionDeadlineHint: 'Après cette date, les contributeurs ne peuvent plus ajouter de contenu',
		maxClipDuration: 'Durée maximale du clip',
		maxClipDurationHint: 'Durée maximale du clip vidéo de chaque contributeur',
		inviteMessage: 'Message d\'invitation',
		inviteMessageHint: 'Message personnalisé affiché aux contributeurs sur la page du tableau',
		inviteMessagePlaceholder: 'p. ex. Enregistrez un message d\'anniversaire pour Sarah !',
		deliveryFormat: 'Format de livraison',
		deliveryFormatHint: 'Comment le destinataire doit-il voir cette carte ?',
		interactiveBoard: 'Tableau interactif',
		interactiveBoardHint: 'Le destinataire voit le tableau de tuiles en direct avec des effets',
		renderedVideo: 'Vidéo rendue',
		renderedVideoHint: 'Le destinataire reçoit une compilation vidéo MP4',
		saving: 'Enregistrement...',
		saveSettings: 'Enregistrer les paramètres',

		// Delivery tab
		cardSent: 'Carte envoyée',
		cardDeliveredTo: 'Cette carte a été remise à %{recipient}.',
		theRecipient: 'le destinataire',
		senderEmail: 'E-mail de l\'expéditeur',
		sendFrom: 'Envoyer depuis',
		defaultCardClan: 'Par défaut (CardClan)',
		senderEmailHint: 'Choisissez l\'adresse e-mail depuis laquelle la carte sera envoyée.',
		recipient: 'Destinataire',
		emailLabel: 'E-mail',
		nameLabel: 'Nom',
		recipientNamePlaceholder: 'Nom du destinataire',
		schedule: 'Programmation',
		sendDateTime: 'Date et heure d\'envoi',
		sendDateTimeHint: 'Choisissez quand livrer la carte. Laissez vide pour l\'envoyer manuellement.',
		autoRenderSend: 'Rendre et envoyer automatiquement à l\'heure programmée',
		autoRenderSendHint: 'La vidéo sera automatiquement rendue et envoyée par e-mail le moment venu.',
		autoRenderSendTag: '(rendu et envoi automatiques)',
		shareLinks: 'Liens de partage',
		inviteContributors: 'Inviter des contributeurs',
		viewCardLabel: 'Voir la carte',
		copy: 'Copier',
		scheduling: 'Programmation...',
		scheduleSend: 'Programmer l\'envoi',
		save: 'Enregistrer',
		sending: 'Envoi...',
		sendNow: 'Envoyer maintenant',
		sentSuccessfully: 'Envoyée avec succès !',
		failedToSend: 'Échec de l\'envoi. Veuillez réessayer.',

		// ===== Upgrade (VideoCardsUpgrade.tsx) =====
		upgradeHelmet: 'Améliorer les cartes vidéo | CardClan',
		limitedTimeOffer: 'Offre à durée limitée',
		upgradeIntro: 'Faites passer vos célébrations au niveau supérieur avec des cartes vidéo rendues. En raison des coûts de calcul, le rendu vidéo comporte des limites d\'utilisation.',
		planFree: 'Gratuit',
		foreverFree: 'Gratuit pour toujours',
		free2Cards: '2 cartes vidéo / mois',
		board10Items: '10 éléments de tableau / carte',
		free20Min: '20 minutes rendues / mois',
		currentPlan: 'Forfait actuel',
		freeTier: 'Niveau gratuit',
		lifetimeDeal: 'Offre à vie',
		perStack: '/ lot',
		oneTimePayment: 'Paiement unique, cumulez jusqu\'à %{max}x',
		currentPlanBadge: 'FORFAIT ACTUEL',
		bestValue: 'MEILLEUR RAPPORT',
		stackSingular: 'lot',
		stackPlural: 'lots',
		yourCurrentPlan: 'Votre forfait actuel (%{count}x %{stacks})',
		planLimits: '%{cards} cartes vidéo / mois · %{minutes} min de rendu / mois',
		ltdCardsPerStack: 'cartes vidéo / mois par lot',
		ltdMinutesPerStack: 'minutes rendues / mois par lot',
		benefitNoFees: 'Aucuns frais récurrents',
		benefitLifetime: 'Accès à vie',
		benefitPriority: 'Rendu prioritaire',
		benefitEarly: 'Tarif de lancement',
		addStacksLabel: 'Ajouter des lots :',
		stacksLabel: 'Lots :',
		maxMore: '(max %{count} de plus)',
		afterPurchase: 'Après l\'achat, vous aurez :',
		processing: 'Traitement...',
		addStacksBtnSingular: 'Ajouter %{count} lot',
		addStacksBtnPlural: 'Ajouter %{count} lots',
		getStacksBtnSingular: 'Obtenir %{count} lot',
		getStacksBtnPlural: 'Obtenir %{count} lots',
		maxStacksReached: 'Nombre maximal de lots atteint (%{count}/%{max})',
	},
};
export default videocards;
